<template>
  <BSCarousel
    :id="id"
    :title="title"
    :bg-blue="options.style === 'dark'"
    :bg-primary="options.style === 'primaryLight'"
    :has-pagination="hasPagination"
    wrap-around
    class="paragraph--padded"
  >
    <template v-if="images">
      <slide
        v-for="(slide, index) in images"
        :key="index"
        :class="{ hidden: isEditing && index > 0 }"
      >
        <ImageSlide
          :total-slides="images.length"
          :label="slide.caption"
          :copyright="slide.copyright"
          :current-slide-number="index + 1"
          :background="options.style"
        >
          <FieldItemTypeImage
            v-bind="slide.image"
            :config="imageStyle"
            img-class="w-full"
          />
        </ImageSlide>
      </slide>
    </template>
  </BSCarousel>
</template>

<script lang="ts" setup>
import { Slide } from 'vue3-carousel'
import type { ParagraphGalleryFragment } from '#graphql-operations'
import ImageSlide from '~/components/BSCarousel/ImageSlide.vue'
import { slugify } from '~/helpers/slugify'

const { options, isEditing } = defineBlokkli({
  bundle: 'gallery',
  globalOptions: ['showInToc', 'bkVisibleLanguages'],
  chunkName: 'gallery',
  options: {
    style: {
      type: 'radios',
      label: 'Farbe',
      default: 'dark',
      displayAs: 'colors',
      options: {
        light: { class: 'bg-white', label: 'Weiss' },
        primaryLight: { class: 'bg-primary-100', label: 'Hellgrün' },
        dark: { class: 'bg-blue-800', label: 'Dunkelblau' },
      },
    },
  },
  editor: {
    editTitle: (el) => el.querySelector('h2')?.innerText,
  },
})

const props = defineProps<{
  title?: ParagraphGalleryFragment['title']
  images?: ParagraphGalleryFragment['images']
}>()

const imageStyle = defineImageStyle({
  type: 'sizes',
  aspectRatio: 16 / 9,
  sizes: {
    sm: 400,
    md: 728,
    lg: 796,
    xl: 1040,
  },
})

const hasPagination = computed(() => (props.images?.length || 0) > 1)

const id = computed(() => slugify(props.title))

defineOptions({
  name: 'ParagraphGallery',
})
</script>
